import { t } from '@hefe/i18n';
import { SelectOption, User } from '@hefe/models';
import {
  currentUserIsAdminSelector,
  currentUserSelector,
  UsersSlice,
} from '@hefe/store';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface EditUserRolesFormProps {
  user: User;
}

export default function EditUserRolesForm(props: EditUserRolesFormProps) {
  const dispatch = useAppDispatch();
  const currentUser = useSelector(currentUserSelector);
  const currentUserIsAdmin = useSelector(currentUserIsAdminSelector);
  const [isSaving, setSaving] = useState(false);

  const submit = (values: any, resetForm: any) => {
    setSaving(true);
    dispatch(
      UsersSlice.updateUserRights({
        id: props.user.id,
        roles: values.roles,
        basketball: true,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setSaving(false));
  };

  const roles: SelectOption[] = [
    {
      label: t('admin'),
      value: 'bb_admin',
      disabled:
        currentUserIsAdmin && currentUser && currentUser.id === props.user.id,
    },
    {
      label: t('coach'),
      value: 'bb_coach',
    },
    {
      label: t('referees.singular'),
      value: 'bb_referee',
    },
    {
      label: t('roles.vehicle_admin'),
      value: 'vehicle_admin',
    },
  ];

  return (
    <CustomForm
      key={`edit-user-roles-${props.user.id}`}
      loading={isSaving}
      fields={[
        {
          name: 'roles',
          label: '',
          placeholder: t('select'),
          rules: [],
          initalValue: props.user.roles,
          multiSelect: true,
          selectOptions: roles,
          disableSelectClear: true,
          type: 'select',
        },
      ]}
      onSubmit={submit}
    />
  );
}
